export const isDraftStatus = (status?: unknown): boolean =>
  String(status || "").trim().toUpperCase() === "DRAFTED";

export const isProductInStock = (
  product: { inStock?: unknown } | null | undefined
): boolean => product?.inStock === true;

export const isSharedCatalogueSold = (
  product: { status?: unknown; inStock?: unknown } | null | undefined
): boolean => !isDraftStatus(product?.status) && !isProductInStock(product);

export const productAvailabilityLabel = (product: {
  status?: unknown;
  inStock?: unknown;
}): string => {
  if (isDraftStatus(product?.status)) {
    return "In progress";
  }
  return isProductInStock(product) ? "In stock" : "Out of stock";
};
